const getPath = () => {
  /** Types:
   * /espn/cfb/scoreboard
   * /espn/cfb/teams
   */
  let hashPath = window.location.hash;
  hashPath = hashPath.split("/");
  if (!hashPath[1]) {
    hashPath[1] = "welcome";
  }
  return {
    page: hashPath[1],
    subpage: hashPath[2],
    params: hashPath[3]
  };
};

export { getPath };
